export const DYNAMIC_CHARTING_TUTORIAL_PATIENT = {
  id: "tutorial-patient",
  full_name: "Juan Dela Cruz",
  first_name: "Juan",
  last_name: "Dela Cruz",
  date_of_birth: "1988-05-25",
  patient_number: "PT-C57352",
  has_medical_history: true,
};

export const DYNAMIC_CHARTING_TODAY_DEMO_APPOINTMENT = {
  id: "tutorial-today-appointment",
  patient_id: "tutorial-patient",
  doctor_name: "Dr. Levi Jordan",
  chair_name: "Chair 1",
  notes: "Walk-in chairside treatment",
  doctor_finished_at: null,
};

export const DYNAMIC_CHARTING_TODAY_DEMO_PROCEDURES = [
  {
    id: "demo-composite-15",
    code: "REST-COMP",
    short_code: "COMP",
    name: "Composite Restoration",
    category: "Restorative",
    default_fee_centavos: 250000,
    additional_surface_pct: 100,
    tooth_specific: true,
    surface_specific: true,
    archived: false,
  },
  {
    id: "demo-extraction-48",
    code: "SURG-EXT",
    short_code: "EXT",
    name: "Tooth Extraction",
    category: "Oral Surgery",
    default_fee_centavos: 300000,
    additional_surface_pct: 100,
    tooth_specific: true,
    surface_specific: false,
    archived: false,
  },
  {
    id: "demo-prophy",
    code: "PREV-PRO",
    short_code: "PRO",
    name: "Oral Prophylaxis",
    category: "Preventive",
    default_fee_centavos: 120000,
    additional_surface_pct: 100,
    tooth_specific: false,
    surface_specific: false,
    archived: false,
  },
];

export const DYNAMIC_CHARTING_FUTURE_NEED_DEMO_PROCEDURES = [
  {
    id: "demo-rct-46",
    code: "ENDO-RCT",
    short_code: "RCT",
    name: "Root Canal Treatment",
    category: "Endodontic",
    default_fee_centavos: 850000,
    additional_surface_pct: 100,
    tooth_specific: true,
    surface_specific: false,
    archived: false,
  },
];

// Safe, local-only catalogue for the Ongoing Treatment tutorial. These are
// the real kinds of services that open the multi-visit choice in Today mode;
// the tutorial uses RCT on #46 as the worked example and keeps the other
// familiar examples visible in the palette.
export const ONGOING_TREATMENT_TUTORIAL_PROCEDURES = [
  {
    id: "demo-ongoing-rct",
    code: "ENDO-RCT",
    short_code: "RCT",
    name: "Root Canal Treatment",
    category: "Endodontic",
    default_fee_centavos: 850000,
    additional_surface_pct: 100,
    tooth_specific: true,
    surface_specific: false,
    visit_count: 3,
    archived: false,
  },
  {
    id: "demo-ongoing-crown",
    code: "REST-CROWN",
    short_code: "CRN",
    name: "Zirconia Crown",
    category: "Restorative",
    default_fee_centavos: 1800000,
    additional_surface_pct: 100,
    tooth_specific: true,
    surface_specific: false,
    visit_count: 3,
    archived: false,
  },
  {
    id: "demo-ongoing-denture",
    code: "PROS-CD",
    short_code: "CD",
    name: "Complete Denture",
    category: "Prosthodontic",
    default_fee_centavos: 3000000,
    additional_surface_pct: 100,
    tooth_specific: false,
    surface_specific: false,
    visit_count: 5,
    multi_tooth_kind: "full_denture",
    archived: false,
  },
];

export const DYNAMIC_CHARTING_TX_PLAN_DEMO_PROCEDURES = [
  {
    id: "demo-tx-rct-46",
    code: "ENDO-RCT",
    short_code: "RCT",
    name: "Root Canal Treatment",
    category: "Endodontic",
    default_fee_centavos: 850000,
    additional_surface_pct: 100,
    tooth_specific: true,
    surface_specific: false,
    visit_count: 2,
    archived: false,
  },
  {
    id: "demo-tx-zirconia-46",
    code: "PROS-ZIRC",
    short_code: "ZIRC",
    name: "Zirconia Crown",
    category: "Restorative",
    default_fee_centavos: 1800000,
    additional_surface_pct: 100,
    tooth_specific: true,
    surface_specific: false,
    visit_count: 3,
    archived: false,
  },
];

export const DYNAMIC_CHARTING_TUTORIAL_ANCHORS = [
  "charting-pen-caries",
  "charting-pen-caries-dentin",
  "charting-pen-caries-enamel",
  "charting-pen-caries-deep",
  "charting-pen-caries-incipient",
  "charting-pen-missing",
  "charting-pen-rct-needed",
  "charting-pen-to-extract",
  "charting-pen-defect-open",
  "charting-pen-calculus-supragingival",
  "doctor-chart-mode-today",
  "doctor-procedures-palette",
  "doctor-procedures-list",
  "doctor-procedure-demo-composite-15",
  "doctor-procedure-demo-extraction-48",
  "doctor-procedure-demo-prophy",
  "charting-today-work",
  "doctor-item-demo-today-composite-15",
  "doctor-item-demo-today-composite-16",
  "doctor-item-demo-today-composite-24",
  "doctor-item-demo-today-composite-27",
  "doctor-item-demo-today-composite-36",
  "doctor-item-demo-today-composite-37",
  "doctor-item-demo-today-composite-44",
  "doctor-item-demo-today-composite-26",
  "doctor-item-demo-today-extraction-48",
  "doctor-item-demo-today-prophy",
  "doctor-whole-mouth-ribbon",
  "doctor-today-subtotals",
  "doctor-today-undo",
  "doctor-mark-patient-done",
  "doctor-chart-mode-future-need",
  "doctor-procedure-demo-rct-46",
  "doctor-item-demo-future-rct-46",
  "doctor-chart-mode-tx-plan",
  "doctor-procedure-demo-tx-rct-46",
  "doctor-procedure-demo-tx-zirconia-46",
  "doctor-item-demo-tx-rct-46",
  "doctor-item-demo-tx-zirconia-46",
  "doctor-visit-demo-tx-rct-46-1",
  "doctor-visit-demo-tx-rct-46-2",
  "doctor-tx-plan-add-phase",
  "doctor-visit-demo-tx-rct-46-2-phase",
  "doctor-visit-demo-tx-zirconia-46-prep",
  "doctor-visit-demo-tx-zirconia-46-try-in",
  "doctor-visit-demo-tx-zirconia-46-cement",
  "doctor-tx-plan-phases",
  "doctor-tx-plan-estimate",
  "doctor-tx-plan-acceptance",
  "checkout-tx-plan-billing-card",
  "checkout-tx-plan-set-billing-model",
  "tx-plan-center-page",
  "tx-plan-center-kpis",
  "tx-plan-center-tabs",
  "txplan-pipeline-view",
  "nav-checkout",
  "checkout-future-needs-step3",
  "checkout-future-book-rct-46",
  "book-slot-10-0",
  "book-future-need-submit",
  "checkout-future-recall-rct-46",
  "checkout-recall-queue",
  "checkout-future-decline-rct-46",
  "checkout-future-declined-popup",
  "charting-tooth-16-surface-o",
  "charting-tooth-15-surface-o",
  "charting-tooth-24-surface-d",
  "charting-tooth-27-surface-o",
  "charting-tooth-36-surface-o",
  "charting-tooth-37-surface-d",
  "charting-tooth-44-surface-o",
  "charting-tooth-26-surface-o",
  "charting-tooth-31-surface-l",
  "charting-tooth-41-surface-l",
  "charting-tooth-18-surface-b",
  "charting-tooth-18-surface-o",
  "charting-tooth-46",
  "charting-tooth-46-surface-o",
  "charting-tooth-48",
  "charting-tooth-48-surface-o",
  "palette-tab-detailed",
  "palette-tab-core",
];

export const DYNAMIC_CHARTING_TUTORIAL_DEMO = {
  draftId: "tutorial-dynamic-charting-draft",
  initialActive: null,
  state: {
    version: 1,
    teeth: {},
    bridges: [],
  },
  findings: [],
  paletteCategories: [
    {
      code: "caries",
      label: "Caries",
      chartLabel: "Caries",
      readbackLabel: "Caries",
      requiresSurfaces: true,
      hasSeverity: true,
      paletteSection: "core_top10",
      colorHex: "#fda4af",
      defaultSeverityCode: "caries_dentin",
      displayOrder: 10,
      severityLevels: [
        { code: "caries_incipient", label: "Incipient", chartLabel: "Incipient", readbackLabel: "Incipient", colorHex: "#fecdd3", rank: 1, displayOrder: 11 },
        { code: "caries_enamel", label: "Enamel", chartLabel: "Enamel", readbackLabel: "Enamel", colorHex: "#fb7185", rank: 2, displayOrder: 12 },
        { code: "caries_dentin", label: "Dentin", chartLabel: "Dentin", readbackLabel: "Dentin", colorHex: "#ef4444", rank: 3, displayOrder: 13 },
        { code: "caries_deep", label: "Deep", chartLabel: "Deep", readbackLabel: "Deep", colorHex: "#991b1b", rank: 4, displayOrder: 14 },
      ],
    },
    {
      code: "defective_restoration",
      label: "Defect",
      chartLabel: "Defect",
      requiresSurfaces: true,
      hasSeverity: true,
      paletteSection: "core_top10",
      colorHex: "#f97316",
      defaultSeverityCode: "defect_open",
      displayOrder: 20,
      severityLevels: [
        { code: "defect_marginal", label: "Marginal", chartLabel: "Marginal", readbackLabel: "Marginal", colorHex: "#fed7aa", rank: 1 },
        { code: "defect_open", label: "Open", chartLabel: "Open", readbackLabel: "Open margin", colorHex: "#f97316", rank: 2 },
        { code: "defect_lost", label: "Lost", chartLabel: "Lost", readbackLabel: "Filling lost", colorHex: "#7c2d12", rank: 3 },
      ],
    },
    {
      code: "fracture",
      label: "Fracture",
      chartLabel: "Fracture",
      requiresSurfaces: true,
      hasSeverity: true,
      paletteSection: "core_top10",
      colorHex: "#d8b4fe",
      defaultSeverityCode: "fracture_enamel",
      displayOrder: 30,
      severityLevels: [
        { code: "fracture_enamel", label: "Enamel craze", chartLabel: "Enamel craze", readbackLabel: "Enamel craze", colorHex: "#e9d5ff", rank: 1 },
        { code: "fracture_dentin", label: "Into dentin", chartLabel: "Into dentin", readbackLabel: "Into dentin", colorHex: "#a855f7", rank: 2 },
      ],
    },
    {
      code: "calculus_supragingival",
      label: "Calculus",
      chartLabel: "Calculus",
      readbackLabel: "Supragingival calculus",
      requiresSurfaces: true,
      hasSeverity: false,
      paletteSection: "core_top10",
      colorHex: "#99f6e4",
      displayOrder: 40,
    },
    {
      code: "mobility",
      label: "Mobility",
      chartLabel: "Mobility",
      requiresSurfaces: false,
      hasSeverity: false,
      paletteSection: "single_pen",
      colorHex: "#ede9fe",
      displayOrder: 80,
    },
    {
      code: "rct_needed",
      label: "RCT Needed",
      chartLabel: "RCT Needed",
      requiresSurfaces: false,
      hasSeverity: false,
      paletteSection: "single_pen",
      colorHex: "#fed7aa",
      displayOrder: 81,
    },
    {
      code: "missing",
      label: "Missing",
      chartLabel: "Missing",
      requiresSurfaces: false,
      hasSeverity: false,
      paletteSection: "single_pen",
      colorHex: "#9ca3af",
      displayOrder: 82,
    },
    {
      code: "to_extract",
      label: "To Extract",
      chartLabel: "To Extract",
      requiresSurfaces: false,
      hasSeverity: false,
      paletteSection: "single_pen",
      colorHex: "#fee2e2",
      displayOrder: 83,
    },
    {
      code: "watch",
      label: "Watch",
      chartLabel: "Watch",
      requiresSurfaces: false,
      hasSeverity: false,
      paletteSection: "single_pen",
      colorHex: "#e0e7ef",
      displayOrder: 84,
    },
  ],
  palettePreferences: {
    activeTab: "core",
    morePaletteExpanded: true,
    legendExpanded: true,
    legendLabelMode: "clinical",
    showFindingLetters: true,
  },
};

export const DYNAMIC_CHARTING_TODAY_DEMO = {
  ...DYNAMIC_CHARTING_TUTORIAL_DEMO,
  draftId: "tutorial-today-charting-draft",
  state: {
    version: 1,
    teeth: {
      "15": { findings: [{ finding_code: "caries_dentin", surfaces: ["O"] }] },
      "16": { findings: [{ finding_code: "caries", surfaces: ["O"] }] },
      "18": { findings: [{ finding_code: "calculus_supragingival", surfaces: ["B"] }] },
      "24": { findings: [{ finding_code: "caries_enamel", surfaces: ["D"] }] },
      "26": { findings: [{ finding_code: "defect_open", surfaces: ["O"] }] },
      "27": { findings: [{ finding_code: "caries_deep", surfaces: ["O"] }] },
      "31": { findings: [{ finding_code: "calculus_supragingival", surfaces: ["L"] }] },
      "36": { findings: [{ finding_code: "caries_dentin", surfaces: ["O"] }] },
      "37": { findings: [{ finding_code: "caries_incipient", surfaces: ["D"] }] },
      "41": { findings: [{ finding_code: "calculus_supragingival", surfaces: ["L"] }] },
      "44": { findings: [{ finding_code: "caries_dentin", surfaces: ["O"] }] },
      "46": { findings: [{ finding_code: "rct_needed", surfaces: [] }] },
      "48": { findings: [{ finding_code: "to_extract", surfaces: [] }] },
    },
    bridges: [],
  },
};

export const DYNAMIC_CHARTING_TX_PLAN_DEMO = {
  ...DYNAMIC_CHARTING_TODAY_DEMO,
  draftId: "tutorial-tx-planning-charting-draft",
};
